import store from 'shared/store'
import passwordReveal from 'views/assets/scripts/passwordReveal'
import { runSafeEachScript } from 'views/assets/scripts/runScripts'
import { REGISTER_FORM_ID } from 'views/consts'
import loadCatalogs from 'views/containers/browser/utils/loadCatalogs'
import buildClientAPI from 'views/providers/clientAPI'

const loadRegisterForm = async () => {
  const container = document.getElementById(REGISTER_FORM_ID)

  const {
    publicConfig: { locale },
  } = store.getPublicRuntimeConfig()
  const i18n = await loadCatalogs(locale)

  const { clientFockService } = buildClientAPI()

  const { default: hydrateComponent } = await import(
    /* webpackChunkName: "RegisterFormContainerWithRender",
    webpackPrefetch: true */
    `./RegisterFormContainerWithRender`
  )

  runSafeEachScript([passwordReveal])

  await hydrateComponent({
    i18n,
    container,
    api: { clientFockService },
  })
}

export default async () => {
  await loadRegisterForm()
}
